import React from 'react'
import { Deal as IDeal } from '../../../../../types/deal'
import DealCard from './Card'
import Typography from '@material-ui/core/Typography'

interface props {
  deals: IDeal[]
  title?: string
}

export default function DealsGrid({ deals, title }: props): JSX.Element {
  return (
    <div>
      {title && title.length > 0 && (
        <Typography align="center" variant="h3">
          {title}
        </Typography>
      )}
      {deals.map((deal) => (
        <DealCard key={deal.url} deal={deal} />
      ))}
    </div>
  )
}
